import { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AnimatePresence, motion, Reorder } from 'framer-motion';
import { KTSVG } from 'src/_metronic/helpers';
import { useUserShortcuts } from './useUserShortcuts';
import ShortcutPicker from './ShortcutPicker';

const ShortcutBar: FC = () => {
  const history = useHistory();
  const { shortcuts, availableByGroup, toggle, remove, reorder } = useUserShortcuts();
  const [pickerOpen, setPickerOpen] = useState(false);

  const keys = shortcuts.map((s) => s.key);

  const navigate = (path: string) => {
    if (history.location.pathname !== path) history.push(path);
  };

  return (
    <div className="shortcut-bar">
      <Reorder.Group as="div" axis="x" values={keys} onReorder={reorder} className="shortcut-bar__pills">
        <AnimatePresence initial={false}>
          {shortcuts.map((s) => (
            <Reorder.Item
              key={s.key}
              value={s.key}
              as="div"
              className="shortcut-pill"
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.6 }}
              whileHover={{ scale: 1.06 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            >
              <button type="button" className="shortcut-pill__btn" onClick={() => navigate(s.path)} title={s.label}>
                <KTSVG path={s.icon} className="shortcut-pill__icon" />
                <span className="shortcut-pill__label">{s.label}</span>
              </button>
              <span
                className="shortcut-pill__remove"
                role="button"
                title="Kaldır"
                onPointerDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation();
                  remove(s.key);
                }}
              >
                <KTSVG path="/media/icons/duotone/Navigation/Close.svg" className="shortcut-pill__remove-icon" />
              </span>
            </Reorder.Item>
          ))}
        </AnimatePresence>
      </Reorder.Group>

      {shortcuts.length === 0 && (
        <button type="button" className="d-flex flex-row align-items-center shortcut-bar__empty" onClick={() => setPickerOpen(true)}>
          <KTSVG path="/media/icons/duotone/General/Thunder-move.svg" className="mr-2 shortcut-bar__empty-icon" />
          Hızlı erişim için kısayol ekleyin
        </button>
      )}

      <motion.button
        type="button"
        className="shortcut-bar__add"
        onClick={() => setPickerOpen(true)}
        whileHover={{ scale: 1.12, rotate: 90 }}
        whileTap={{ scale: 0.9 }}
        transition={{ type: 'spring', stiffness: 400, damping: 15 }}
        title="Kısayol ekle / düzenle"
      >
        <KTSVG path="/media/icons/duotone/Navigation/Plus.svg" className="shortcut-bar__add-icon svg-icon-white" />
      </motion.button>

      <ShortcutPicker open={pickerOpen} onClose={() => setPickerOpen(false)} availableByGroup={availableByGroup} onToggle={toggle} />
    </div>
  );
};

export default ShortcutBar;
